export const ParticipantRole = Object.freeze({
  RECOVERER: "RECOVERER",
  DEBTOR: "DEBTOR",
  BORROWER: "BORROWER",
  DOVERENNYI: "DOVERENNYI",
});

export const DEBTOR_ROLES = Object.freeze([
  ParticipantRole.DEBTOR,
  ParticipantRole.BORROWER,
]);
